import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { EmpresaAfiliadoItem } from "./EmpresaAfiliadoItem";
import {
  Button,
  Grid,
  Fab,
  Icon,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { NuevaEmpresaAfiliado } from "./NuevaEmpresaAfiliado";
import NuevaEmpresaModal from "../empresas/NuevaEmpresaModal";
import { empresaLimpiar } from "../../actions/empresas/empresas";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(16),
      height: theme.spacing(16),
    },
  },
  container: {
    width: "80vw",
  },
  texto: {
    padding: 2,
    margin: 3,
    width: "60vw",
  },
  iconoAdd: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    color: "#fff",
    backgroundColor: green[500],
    marginTop: 35,
    marginRight: 35,
  },
  divContenedor: {
    display: "flex",
    justifyContent: "space-between",
  },
  contenedorEmpresas: {
    maxHeight: 300,
    overflow: "auto",
  },
  gridNone: {
    pointerEvents: "none",
    opacity: 0.4,
  },
}));

export const EmpresasAfiliado = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { cargada, items: empresas } = useSelector(
    (state) => state.empresasAfiliado
  );

  const [abrir, setAbrir] = useState(false);
  const [abrirNuevaEmpresa, setAbrirNuevaEmpresa] = useState(false);
  const [mostrarAnteriores, setMostrarAnteriores] = useState(false);

  const handleEmpresaInsertar = (e) => {
    e.preventDefault();
    setAbrir(true);
  };

  const handleAddEmpresa = (e) => {
    e.preventDefault();
    dispatch(empresaLimpiar());
    setAbrirNuevaEmpresa(true);
  };

  const mostrarAnterioresHandler = () => {
    setMostrarAnteriores((previusValue) => !previusValue);
  };

  if (empresas?.length > 0) {
    empresas.sort((a, b) => new Date(b.fechaDesde) - new Date(a.fechaDesde));
  }

  const hoy = new Date();
  const empresasAnteriores = empresas.filter((empresa) => {
    if (empresa.fechaHasta !== null) {
      if (new Date(empresa.fechaHasta) < hoy) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  const empresasActuales = empresas.filter((empresa) => {
    if (empresa.fechaHasta === null || new Date(empresa.fechaHasta) > hoy) {
      return true;
    } else {
      return false;
    }
  });

  return (
    <div className={props.idForm === "formConsulta" && props.isReactivaciones === undefined? classes.gridNone : null}>
      <NuevaEmpresaAfiliado abrirModal={abrir} setAbrirModal={setAbrir} />
      <NuevaEmpresaModal
        abrirModal={abrirNuevaEmpresa}
        setAbrirModal={setAbrirNuevaEmpresa}
      />
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Fab
            className={classes.buttonOk}
            color="secondary"
            aria-label="add"
            size="medium"
            onClick={handleEmpresaInsertar}
          >
            <AddIcon />
          </Fab>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddEmpresa}
            className={classes.button}
            endIcon={<Icon>add</Icon>}
          >
            Incorporar Nueva Empresa
          </Button>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "1rem" }}>
        {cargada && empresas.length > 0 && (
          <>
            <Grid item xs={9}>
              <Grid container>
                {empresasActuales.map((item) => (
                  <Grid item xs={12} key={item.idEmpresasAfiliados}>
                    <EmpresaAfiliadoItem item={item} from="AFILIACIONES" anteriores={false}/>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={mostrarAnterioresHandler}
              style={{ marginTop: "1.5rem", marginBottom: "1rem", marginLeft: "0.3rem" }}
            >
              Anteriores
            </Button>
            </Grid>
            <Grid item xs={10} />
            {mostrarAnteriores && (
              <>
                <Grid item xs={9}>
                  <Grid container>
                    {empresasAnteriores.map((item) => (
                      <Grid item xs={12} key={item.idEmpresasAfiliados}>
                        <EmpresaAfiliadoItem item={item} from="AFILIACIONES" anteriores={true}/>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item xs={6} />
              </>
            )}
          </>
        )}
      </Grid>
    </div>
  );
};
